import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentAtlas: null,
    currentVideoChapter: null,
    currentBodypart: null,
    currentExam: null,
    bookURL: '',
  },
  mutations: {
  },
  actions: {

  },
});
